import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonButton } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { AccountService } from '../../account';
import { AuthService } from '../../auth';

@Component({
  selector: 'lib-my-account-password-logout',
  templateUrl: './my-account-password-logout.component.html',
  styleUrls: ['./my-account-password-logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonButton, CommonModule, TranslateModule, RouterLink, RouterLinkActive],
})
export class MyAccountPasswordLogoutComponent {
  private readonly accountService = inject(AccountService);
  private readonly authService = inject(AuthService);

  public account = this.accountService.account;

  // constructor() {  }

  logout(): void {
    this.authService.logout();
  }
}
